export default "__VITE_ASSET__CSTY4bS2__"